"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ProductDescriptionWrap = styled_components_1.default.div(({ theme }) => (Object.assign(Object.assign({}, theme.text.richText), theme.product.productDescriptionWrap)));
const ProductDescription = ({ leadText, blocks, sellingPropositions, }) => {
    return (React.createElement(ProductDescriptionWrap, null,
        sellingPropositions && (React.createElement("div", { dangerouslySetInnerHTML: { __html: sellingPropositions } })),
        leadText && (React.createElement("div", { className: "lead-text", dangerouslySetInnerHTML: { __html: leadText } })),
        (blocks || []).map(({ title, text }, i) => {
            return (React.createElement("div", { key: i, className: "block" },
                title && React.createElement("h3", { dangerouslySetInnerHTML: { __html: title } }),
                text && React.createElement("div", { dangerouslySetInnerHTML: { __html: text } })));
        })));
};
exports.default = ProductDescription;
//# sourceMappingURL=ProductDescription.js.map